export default {
  "organizationSettings": {
    "headerTitle": "Organization Settings",
    "headerDesc": "Change the configuration of your organization's settings.",
    "saveButton": "Save",
    "generalTab": {
      "header": "General",
      "title": "General",
      "desc": "This default settings will be applied to the entire organization account.",
      "warehouseRetention": {
        "title": "Warehouse Retention Policy",
        "storageInfoLabel": "Warehouse storage",
        "storageInfoMsg": "Used space {used}/{total} GB",
        "inputLabel": "Retention period",
        "inputDesc":
          "Set your retention period. Dataset versions exceeding this period of time, will be automatically deleted. The latest dataset version is always saved regardless of the retention setting.",
        "inputInfo": "Datasets version created before {date} will be deleted at midnight.",
        "inputUnit": "days"
      }
    },
    "credentialsTab": {
      "header": "Credentials",
      "title": "Connect to the {organizationName} Warehouse",
      "desc": "Use the following credentials to connect to this organization's data warehouse.",
      "instructions": "Your personal credentials provided allow you to access sources and datasets for this organization.",
      "serverAddressLabel": "Server Address",
      "portNumberLabel": "Port",
      "databaseNameLabel": "Database Name",
      "usernameLabel": "Username",
      "passwordLabel": "Password",
      "copyButton": "Copy",
      "generateButton": "Generate",
      "resetButton": "Reset",
      "generateModal": {
        "title": "Warehouse Password for {organizationName}",
        "instructions": "Your password has been generated. It won't be accessible on the BEEM app once you quit this modal dialog.",
        "checkboxTitle": "Check the following items to reveal your password:",
        "checkboxText1": "BEEM does not store my warehouse password.",
        "checkboxText2": "My password is unrecoverable and will need to be reset in case it is lost.",
        "checkboxText3": "My password should be stored securely through a password manager or in a file.",
        "passwordLabel": "New password",
        "revealButton": "Reveal",
        "copyButton": "Copy",
        "mainButton": "I've stored my password"
      },
      "resetModal": {
        "title": "Reset Warehouse Credential Password",
        "instructions": "Warning: Resetting your password will invalidate all your passwords used in external tools. You'll need to change your password in all external tools it's been used.",
        "resetText": "Are you sure you want to reset your password?",
        "resetButton": "Reset",
        "userNotFoundError": "No warehouse credential exists yet for your account. Generate a password first before trying to reset it.",
        "errorButton": "Close",
        "generateButton": "Generate a password"
      }
    },
    "aiContextTab": {
      "header": "AI Center",
      "title": "AI Center",
      "desc": "Tell AI features about your organization. Identity and branding are injected as context into every AI prompt."
    },
    "usageTab": {
      "header": "Usage &\u00a0Billing",
      "title": "Usage & Billing",
      "desc": "Consumption for the current cycle, and the plan and invoices it is billed against.",
      "usage": "Usage",
      "billing": "Billing",
      "cycle": "This month \u00b7 from {from} \u00b7 resets in {days} days",
      "compare": "Compare with last month",
      "thisMonth": "This month",
      "dataProcessing": "Data processing",
      "dpu": "DPU",
      "dpuAllowance": "Of {allowance} DPU included each cycle",
      "noDpuAllowance": "Billed on consumption \u2014 this plan includes no DPU allowance",
      "dpuIncluded": "{allowance} DPU included",
      "portalError": "Could not open the billing portal. Please try again or contact support.",
      "invoiceError": "Could not prepare that invoice. Please try again, or open the billing portal.",
      "storage": "Storage",
      "dataLake": "Data lake",
      "warehouse": "Warehouse",
      "storageCombined": "Data lake and warehouse combined",
      "storageAllowance": "Of {allowance} GB included each cycle",
      "storageIncluded": "{allowance} GB included",
      "overAllowance": "{over} GB above the storage included in this plan.",
      "warehouseIncludedNote": "Warehouse storage runs on a dedicated warehouse included in your plan, so it is not billed on consumption.",
      "chartCurrent": "This cycle",
      "chartPrevious": "Last cycle",
      "chartDay": "Day",
      "chartNoData": "No daily records for either cycle yet.",
      "delta": "{arrow} {percent}% vs the same day last cycle",
      "deltaFlat": "Unchanged from the same day last cycle",
      "portal": "Manage Billing",
      "planMeta": "Every {period} {unit}",
      "noPlan": "No plan on file",
      "storageNone": "Nothing measured yet",
      "warehouseIncludedNoteWithCapacity": "Warehouse storage runs on a dedicated warehouse included in your plan, with {capacity} GB provisioned, so it is not billed on consumption.",
      "billingUnavailable": "Billing details could not be loaded. Please try again shortly or contact support.",
      "projectedThisCycle": "Projected this cycle: {value} {unit}",
      "projectedNextCycle": "Projected next cycle: {value} {unit}",
      "projectionEarly": "(early in the cycle)",
      "projectionNoHistory": "(not enough history for a trend)",
      "invoiceStatus": {
        "paid": "Paid",
        "posted": "Payment due",
        "payment_due": "Payment due",
        "not_paid": "Unpaid",
        "voided": "Voided",
        "pending": "Pending"
      },
      "invoices": "Recent invoices",
      "noBilling": "Billing for this organization is not managed in Chargebee."
    },
    "usersTab": {
      "header": "Users & Access",
      "title": "Manage access",
      "desc": "Manage user organization and workspace roles, memberships and ownership of accounts that have access to your organization.",
      "filter": "Filter members by name or username",
      "subtitles": {
        "user": "{numberOfUsers} Users",
        "membership": "Membership"
      },
      "workspaces": "{numberOfWorkspaces} Workspaces",
      "dropdown": {
        "delete": "Remove from organization"
      }
    }
  }
};
